export class AnalyticsLoginModel {
    public id: string = '';
    public apiKey: string = '';

    constructor() {}
}